import { produce } from "immer";
import {
  SET_QUERY_SUCCESS,
  SET_QUERY_FILTERS_SUCCESS,
} from "../events/queryEvents";

const initialState = {
  query: "",
  filters: { taggedFiles: [] },
};

const filesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_QUERY_SUCCESS: {
      const { query } = action.payload;
      return produce(state, (draft) => {
        draft.query = query;
      });
    }
    case SET_QUERY_FILTERS_SUCCESS: {
      const { filters } = action.payload;
      return produce(state, (draft) => {
        draft.filters = filters;
      });
    }
    default: {
      return state;
    }
  }
};

export default filesReducer;
